var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import services from '../../services';
import { loadApps } from '../../containers/Root/actions';
// import { loadSelectedApp } from '../../store/selectedApp/actions';
var AppService = services.AppService;
export var appClone = function (appId, req) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'AppSettings/CLONE_REQUEST' });
                    return [4 /*yield*/, AppService.cloneApp(appId, req)];
                case 1:
                    _a.sent();
                    dispatch({ type: 'AppSettings/CLONE_SUCCESS' });
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    if ((error_1 === null || error_1 === void 0 ? void 0 : error_1.status) === 429) {
                        dispatch({ type: 'AppSettings/DELETE_DEVPLAN_FAILURE' });
                    }
                    else {
                        dispatch({ type: 'AppSettings/CLONE_FAIL' });
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var appUpdateVersion = function (appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    dispatch({ type: 'AppSettings/UPDATE_VERSION_REQUEST' });
                    return [4 /*yield*/, AppService.updateAppVersion(appId)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, dispatch(loadApps())];
                case 2:
                    _a.sent();
                    dispatch({ type: 'AppSettings/UPDATE_VERSION_SUCCESS' });
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    console.error(e_1);
                    dispatch({ type: 'AppSettings/UPDATE_VERSION_FAILURE' });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var checkDelete = function (appId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var checkData, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'AppSettings/CHECK_DELETE_REQUEST' });
                return [4 /*yield*/, AppService.checkDelete(appId)];
            case 1:
                checkData = (_a.sent()).objects;
                dispatch({ type: 'AppSettings/CHECK_DELETE_SUCCESS', checkData: checkData });
                return [3 /*break*/, 3];
            case 2:
                e_2 = _a.sent();
                dispatch({ type: 'AppSettings/CHECK_DELETE_FAILURE' });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var appDelete = function (appId, organizationId, navigate) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    dispatch({ type: 'AppSettings/DELETE_REQUEST' });
                    return [4 /*yield*/, AppService.deleteApp(appId)];
                case 1:
                    _a.sent();
                    navigate("/organizations/".concat(organizationId, "/apps"));
                    return [4 /*yield*/, dispatch(loadApps())];
                case 2:
                    _a.sent();
                    dispatch({ type: 'AppSettings/DELETE_SUCCESS' });
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    if ((error_2 === null || error_2 === void 0 ? void 0 : error_2.status) === 409) {
                        dispatch({ type: 'AppSettings/DELETE_SHARED_APP_FAILURE' });
                    }
                    else {
                        dispatch({ type: 'AppSettings/DELETE_FAILURE' });
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var clearAppData = function (appId, dataType) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                dispatch({
                    type: 'AppSettings/CLEAR_APP_DATA_REQUEST',
                });
                return [4 /*yield*/, AppService.clearAppData(appId, dataType)];
            case 1:
                _a.sent();
                return [4 /*yield*/, dispatch(getAppData(appId))];
            case 2:
                _a.sent();
                dispatch({ type: 'AppSettings/CLEAR_APP_DATA_SUCCESS' });
                return [3 /*break*/, 4];
            case 3:
                err_1 = _a.sent();
                dispatch({ type: 'AppSettings/CLEAR_APP_DATA_FAILURE', err: err_1 });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/, null];
        }
    });
}); }; };
export var getAppData = function (appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var appData, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({
                        type: 'AppSettings/GET_APP_DATA_REQUEST',
                    });
                    return [4 /*yield*/, AppService.getAppData(appId)];
                case 1:
                    appData = (_a.sent()).object;
                    dispatch({ type: 'AppSettings/GET_APP_DATA_SUCCESS', appData: appData });
                    return [3 /*break*/, 3];
                case 2:
                    err_2 = _a.sent();
                    dispatch({ type: 'AppSettings/GET_APP_DATA_FAILURE', err: err_2 });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
